/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { useUserContext } from "../../../../context/user/UserContext";
import { pushOneUser } from "../../../../middlewares/sysNavigation/SysNavigation";
import { Modal, Search, MyButton, Pagination } from "../../component/Component";

// const addRoute = "/user/add";
const editRoute = "/user/edit";

const Overview = () => {
  const [usersList, setUsersList] = useState([]);
  const { users, fetchUsers, count } = useUserContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!users) fetchUsers(page, pageSize);
    else setUsersList(users);
  }, [users]);

  const SearchList = (e) => {
    const key = String(e?.target?.value ?? "").toLowerCase();
    if (!users || users.length === 0) return setUsersList([]);

    if (!key) return setUsersList(users);

    const searchArray = [];
    users.forEach((_user_) => {
      if (
        String(_user_?.email ?? "").toLowerCase().includes(key) ||
        String(_user_?.phonenumber ?? "").toLowerCase().includes(key) ||
        String(_user_?.first_name ?? "").toLowerCase().includes(key) ||
        String(_user_?.last_name ?? "").toLowerCase().includes(key)
      ) {
        searchArray.push(_user_);
      }
    });
    setUsersList(searchArray);
  };

  const total = count ?? usersList?.length ?? 0;

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto max-w-6xl space-y-5">
        {/* Header / Intro */}
        <div className="relative">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Users
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Manage user accounts and details. Use search to filter quickly.
                </p>
              </div>
              <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-[11px] text-gray-700">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                Total Users
                <span className="ml-2 rounded-md bg-white px-2 py-0.5 font-semibold ring-1 ring-gray-200">
                  {total}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="p-4">
            <Search
              props={{
                title: "Search users by name, email or phone…",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
        </div>

        {/* Table */}
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="relative max-h-[65vh] overflow-auto">
            <table className="min-w-full text-sm">
              <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
                <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                  <th className="px-4 py-3 font-semibold">Full Name</th>
                  <th className="px-4 py-3 font-semibold">Email</th>
                  <th className="px-4 py-3 font-semibold">Phone</th>
                  <th className="px-4 py-3 font-semibold text-center">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {users ? (
                  (usersList?.length ? usersList : []).map((_user_) => {
                    const initials = `${(_user_.first_name || "").slice(0, 1)}${(_user_.last_name || "").slice(0, 1)}`
                      .toUpperCase()
                      .trim() || "U";
                    const fullName = `${_user_.first_name ?? ""} ${_user_.last_name ?? ""}`.trim() || "—";
                    return (
                      <tr
                        key={_user_.user_id}
                        className="group hover:bg-gray-50/60"
                      >
                        <td className="px-4 py-3 align-middle">
                          <div className="flex items-center gap-3">
                            <div className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-white text-[10px] font-bold shadow-sm">
                              {initials}
                            </div>
                            <div className="min-w-0">
                              <div className="truncate font-medium text-gray-900">
                                {fullName || "—"}
                              </div>
                              <div className="truncate text-[11px] text-gray-500">
                                {(_user_?.country ?? "").toString()}
                              </div>
                            </div>
                          </div>
                        </td>

                        <td className="px-4 py-3 align-middle">
                          <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs text-gray-700 ring-1 ring-gray-200">
                            {_user_.email || "—"}
                          </span>
                        </td>

                        <td className="px-4 py-3 align-middle text-gray-700">
                          {_user_.phonenumber || "—"}
                        </td>

                        <td className="px-4 py-3 align-middle">
                          <div className="flex justify-center">
                            <ActionButton props={_user_} />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="px-4 py-6 text-center text-gray-500" colSpan={4}>
                      Loading users…
                    </td>
                  </tr>
                )}
                {users && usersList?.length === 0 && (
                  <tr>
                    <td className="px-4 py-6 text-center text-gray-500" colSpan={4}>
                      No users match your search.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Footer / Pagination */}
          <div className="border-t border-gray-100 px-4 py-3">
            <div className="flex items-center justify-end">
              <Pagination
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                total_items={count}
                callbackFunction={(_page_, _pageSize_) => {
                  fetchUsers(_page_, _pageSize_);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const [showModal, setShowModal] = useState(false);
  const { users, updateUserState, deleteUser } = useUserContext();

  const user_id = props.user_id;
  const user_name = props.fullname;
  const _user_ = props;

  const deleteOneUserById = async (user_id) => {
    const { status } = await deleteUser(user_id);
    if (status === 200) {
      if (users) {
        const update = users.filter((_u) => _u.user_id !== user_id);
        updateUserState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: user_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneUserById(user_id),
        }}
      />

      <div
        className={[
          "inline-flex w-full max-w-[520px] flex-wrap items-center justify-center gap-2",
          "rounded-xl border border-gray-200 bg-white/70 px-3 py-2 shadow-sm",
        ].join(" ")}
      >
        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className="rounded-lg bg-gradient-to-br from-blue-700 to-blue-600 hover:from-blue-800 hover:to-blue-700 px-3 py-2 text-xs font-semibold"
            onClick={() => pushOneUser(_user_)}
          />
        </Link>
        <MyButton
          title="Delete"
          className="rounded-lg bg-gradient-to-br from-rose-700 to-rose-600 hover:from-rose-800 hover:to-rose-700 px-3 py-2 text-xs font-semibold"
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
